import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { BankChronologyRequest } from "../../api/banks.api";
// import { API_CENTER } from "../../../services/api/api";
// import { message } from "antd";

export interface BankChronology {
  bank_id: number;
  base_rate: string;
  commission_agent_rate: string;
  commission_tatBg_rate: string;
  end_date: string;
  excess_agent: string;
  excess_bank: string;
  excess_tatBg: string;
  id: number;
  start_date: string;
}
export interface IBank {
  id: number;
  key?: string;
  title: string;
  excess: string;
  base_rate?: string;
  min_sum_bg?: string;
  max_sum_bg?: string;
  is_enabled: boolean;
  bank_data_chronologies: BankChronology[];
  bank_data_chronology_today: BankChronology | null;
}

interface IBankForm {
  BANK_FORM_DISABLED: boolean;
  BANK_FORM_INITIAL: Pick<IBank, "title" | "excess">;
  BANK_FORM_TYPE: "ADD" | "EDIT" | "INFO";
}

interface BanksState {
  BANKS_ACTIVE: IBank[];
  BANKS_ARCHIVE: IBank[];
  SELECTED_BANK: IBank;
  BANK_FORM: IBankForm;
}

const initialState: BanksState = {
  BANKS_ACTIVE: [],
  BANKS_ARCHIVE: [],
  SELECTED_BANK: {} as IBank,
  BANK_FORM: {
    BANK_FORM_DISABLED: true,
    BANK_FORM_INITIAL: {
      title: "",
      excess: "",
    },
    BANK_FORM_TYPE: "INFO",
  },
};

// const API = new API_CENTER();
// export const API_BANK_ARCHIVE = createAsyncThunk<
//   { bank_id: number; is_enabled: boolean },
//   { bank_id: number; is_enabled: boolean },
//   {
//     rejectValue: string;
//   }
// >("banksSlice/API_BANK_ARCHIVE", async (value, { rejectWithValue }) => {
//   const response = await API.GET_API(`bank/${value.bank_id}/enable`, "PATCH", {
//     is_enabled: value.is_enabled,
//   });
//   if (response.success) {
//     return { bank_id: value.bank_id, is_enabled: value.is_enabled };
//   } else {
//     return rejectWithValue(response);
//   }
// });

// export const API_BANK_ADD = createAsyncThunk<
//   IBank,
//   {
//     title: string;
//     base_rate: string;
//     excess: string;
//   },
//   {
//     rejectValue: string;
//   }
// >("banksSlice/API_BANK_ADD", async (value, { rejectWithValue }) => {
//   const response = await API.GET_API(`bank`, "POST", {
//     title: value.title,
//     base_rate: value.base_rate,
//     excess: value.excess,
//   });
//   if (response.success) {
//     return response.data;
//   } else {
//     return rejectWithValue(response);
//   }
// });

// export const API_BANK_EDIT = createAsyncThunk<
//   IBank,
//   {
//     id: number;
//     title: string;
//     base_rate: string;
//     excess: string;
//   },
//   {
//     rejectValue: string;
//   }
// >("banksSlice/API_BANK_EDIT", async (value, { rejectWithValue }) => {
//   const response = await API.GET_API(
//     `bank/${value.id}
//   `,
//     "PUT",
//     {
//       title: value.title,
//       base_rate: value.base_rate,
//       excess: value.excess,
//     }
//   );
//   if (response.success) {
//     return response.data;
//   } else {
//     return rejectWithValue(response);
//   }
// });

// export const API_BANK_DELETE = createAsyncThunk<
//   number,
//   {
//     id: number;
//   },
//   {
//     rejectValue: string;
//   }
// >("banksSlice/API_BANK_DELETE", async (value, { rejectWithValue }) => {
//   const response = await API.GET_API(`bank/${value.id}`, "DELETE");
//   if (response.success) {
//     return value.id;
//   } else {
//     return rejectWithValue(response);
//   }
// });

// страница списка банков
const banksSlice = createSlice({
  name: "BANKS_SLICE",
  initialState: initialState,
  reducers: {
    // обновить список банков
    UP_DATE_BANKS_LIST: (state, actions: PayloadAction<IBank[], string>) => {
      const banks = actions.payload.reduce(
        (acc, obj) => {
          if (obj.is_enabled === true) {
            acc.active.push(obj);
          } else {
            acc.archive.push(obj);
          }
          return acc;
        },
        { active: [], archive: [] } as {
          active: IBank[];
          archive: IBank[];
        }
      );
      state.BANKS_ACTIVE = banks.active;
      state.BANKS_ARCHIVE = banks.archive;
    },
    // изменить выбранный банк
    CHANGE_SELECTED_BANK: (state, actions: PayloadAction<IBank, string>) => {
      state.SELECTED_BANK = actions.payload;
    },
    // изменить начальное значение в форме отображения информации о банке
    CHANGE_BANK_FORM_INITIAL: (
      state,
      actions: PayloadAction<Pick<IBank, "title" | "excess">, string>
    ) => {
      state.BANK_FORM.BANK_FORM_INITIAL = actions.payload;
    },
    // изменить доступ к полям формы
    CHANGE_BANK_FORM_DISABLE: (
      state,
      actions: PayloadAction<boolean, string>
    ) => {
      state.BANK_FORM.BANK_FORM_DISABLED = actions.payload;
    },
    // изменить тип формы вывода информации о банке
    CHANGE_BANK_FORM_TYPE: (
      state,
      actions: PayloadAction<"ADD" | "EDIT" | "INFO", string>
    ) => {
      state.BANK_FORM.BANK_FORM_TYPE = actions.payload;
    },
    // обновить списки активных и неактивных банков
    UP_DATE_BANKS_STORE: (state, actions: PayloadAction<IBank[], string>) => {
      if (actions.payload) {
        const banks = actions.payload.reduce(
          (acc, obj) => {
            if (obj.is_enabled === true) {
              acc.active.push(obj);
            } else {
              acc.archive.push(obj);
            }
            return acc;
          },
          { active: [], archive: [] } as {
            active: IBank[];
            archive: IBank[];
          }
        );
        state.BANKS_ACTIVE = banks.active;
        state.BANKS_ARCHIVE = banks.archive;
        if (banks.active.length > 0) {
          state.SELECTED_BANK = banks.active[0];
          state.BANK_FORM.BANK_FORM_INITIAL = banks.active[0];
        }
      }
    },
    // добавить банк в архив
    BANK_ARCHIVE: (state, actions) => {
      const updatedBanks = state.BANKS_ACTIVE.concat(state.BANKS_ARCHIVE).map(
        (bank: IBank) => {
          if (bank.id === actions.payload.bank_id) {
            return {
              ...bank,
              is_enabled: actions.payload.is_enabled,
            };
          }
          return bank;
        }
      );

      const banks = updatedBanks.reduce(
        (acc: { active: IBank[]; archive: IBank[] }, bank: IBank) => {
          if (bank.is_enabled === true) {
            acc.active.push(bank);
          } else {
            acc.archive.push(bank);
          }
          return acc;
        },
        { active: [], archive: [] } as {
          active: IBank[];
          archive: IBank[];
        }
      );
      state.BANKS_ACTIVE = banks.active;
      state.BANKS_ARCHIVE = banks.archive;
    },
    // изменение данных о банке
    BANK_EDIT: (state, actions) => {
      state.SELECTED_BANK = actions.payload;
      state.BANKS_ACTIVE = state.BANKS_ACTIVE.map((bank: IBank) =>
        bank.id === actions.payload.id ? actions.payload : bank
      );
      state.BANKS_ARCHIVE = state.BANKS_ARCHIVE.map((bank: IBank) =>
        bank.id === actions.payload.id ? actions.payload : bank
      );
    },
    // удалить банк
    DELETE_BANK: (state, actions: PayloadAction<number, string>) => {
      state.BANKS_ACTIVE = state.BANKS_ACTIVE.filter(
        (bank) => bank.id !== actions.payload
      );
      state.BANKS_ARCHIVE = state.BANKS_ARCHIVE.filter(
        (bank) => bank.id !== actions.payload
      );
    },
    // добавить новый банк
    ADD_NEW_BANK: (state, actions: PayloadAction<IBank, string>) => {
      state.BANKS_ACTIVE.push(actions.payload);
    },

    ADD_BANK_CHRONOLOGY: (
      state,
      actions: PayloadAction<{
        actual: BankChronology;
        last_added: BankChronologyRequest;
      }>
    ) => {
      const selectedBank = state.SELECTED_BANK;
      const chronologyData = actions.payload;
      const lastItem = selectedBank.bank_data_chronologies.pop();
      if (lastItem) {
        lastItem.end_date = dayjs(chronologyData.last_added.start_date)
          .subtract(1, "day")
          .format("DD-MM-YYYY");
        selectedBank.bank_data_chronologies.push(lastItem);
      }

      selectedBank.bank_data_chronologies.push({
        ...chronologyData.last_added,
        bank_id: chronologyData.actual.bank_id,
        end_date: "2099-01-01",
        id: chronologyData.actual.id,
      });
      selectedBank.bank_data_chronology_today = chronologyData.actual;
    },
  },
  // extraReducers: (builder) => {
  // builder.addCase(API_BANK_ARCHIVE.fulfilled, (state, actions) => {
  //   const updatedBanks = state.BANKS_ACTIVE.concat(state.BANKS_ARCHIVE).map(
  //     (bank) => {
  //       if (bank.id === actions.payload.bank_id) {
  //         return {
  //           ...bank,
  //           is_enabled: actions.payload.is_enabled,
  //         };
  //       }
  //       return bank;
  //     }
  //   );
  //   const banks = updatedBanks.reduce(
  //     (acc, bank) => {
  //       if (bank.is_enabled === true) {
  //         acc.active.push(bank);
  //       } else {
  //         acc.archive.push(bank);
  //       }
  //       return acc;
  //     },
  //     { active: [], archive: [] } as {
  //       active: IBank[];
  //       archive: IBank[];
  //     }
  //   );
  //   state.BANKS_ACTIVE = banks.active;
  //   state.BANKS_ARCHIVE = banks.archive;
  // });
  // builder.addCase(API_BANK_ARCHIVE.rejected, (state, actions) => {
  //   const errorMessage = actions.error.message;
  //   message.error(errorMessage);
  // });
  // builder.addCase(API_BANK_ADD.fulfilled, (state, actions) => {
  //   state.BANKS_ACTIVE.push(actions.payload);
  // });
  // builder.addCase(API_BANK_ADD.rejected, (state, actions) => {
  //   const errorMessage = actions.error.message;
  //   message.error(errorMessage);
  // });
  // builder.addCase(API_BANK_EDIT.fulfilled, (state, actions) => {
  //   state.SELECTED_BANK = actions.payload;
  //   state.BANKS_ACTIVE = state.BANKS_ACTIVE.map((bank) =>
  //     bank.id === actions.payload.id ? actions.payload : bank
  //   );
  // });
  // builder.addCase(API_BANK_EDIT.rejected, (state, actions) => {
  //   const errorMessage = actions.error.message;
  //   message.error(errorMessage);
  // });
  // builder.addCase(API_BANK_DELETE.fulfilled, (state, actions) => {
  //   state.BANKS_ACTIVE = state.BANKS_ACTIVE.filter(
  //     (bank) => bank.id !== actions.payload
  //   );
  // });
  // builder.addCase(API_BANK_DELETE.rejected, (state, actions) => {
  //   const errorMessage = actions.error.message;
  //   message.error(errorMessage);
  // });
  // },
});

export const {
  UP_DATE_BANKS_LIST,
  CHANGE_SELECTED_BANK,
  CHANGE_BANK_FORM_INITIAL,
  CHANGE_BANK_FORM_DISABLE,
  CHANGE_BANK_FORM_TYPE,
  UP_DATE_BANKS_STORE,
  BANK_ARCHIVE,
  BANK_EDIT,
  DELETE_BANK,
  ADD_NEW_BANK,
  ADD_BANK_CHRONOLOGY,
} = banksSlice.actions;
export default banksSlice.reducer;
